module.exports = __webpack_public_path__ + "site/img/45.6ffe2125.jpg";